import { DateHighlighter } from "./date"
import { Highlighted } from "./highlighted"
import { MentionHighlighter } from "./mention"
import { TagHighlighter } from "./tag"

export { highlight } from "./highlight"

export const markdownExtensions = [TagHighlighter, MentionHighlighter, DateHighlighter, Highlighted]
